module.exports = __webpack_public_path__ + "img/particles-grayscale.b7e7f19a.svg";